/**
 * Klaviyo Back in Stock - Ultra simple instant switching
 */

(function() {
  'use strict';

  if (!window.klaviyoBISEnable) return;

  // Add CSS to hide sold out button when Klaviyo button is present
  const style = document.createElement('style');
  style.textContent = `
    /* Hide sold out button when Klaviyo BIS is present */
    .h-stack:has(.klaviyo-bis-trigger) button[type="submit"][disabled]:not(.klaviyo-bis-trigger) {
      display: none !important;
    }

    /* Show Klaviyo button when submit button is disabled */
    .h-stack:has(button[type="submit"][disabled]) .klaviyo-bis-trigger {
      display: block !important;
    }

    /* Hide Klaviyo button when submit button is enabled */
    .h-stack:has(button[type="submit"]:not([disabled])) .klaviyo-bis-trigger {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  // Update Klaviyo button data on variant change
  document.addEventListener('variant:change', function(event) {
    if (!event.detail || !event.detail.variant) return;

    const variant = event.detail.variant;
    const productForm = event.target;
    const klaviyoButton = productForm.querySelector('.klaviyo-bis-trigger');

    if (klaviyoButton) {
      klaviyoButton.setAttribute('data-variant-id', variant.id);
      if (variant.product_id) {
        klaviyoButton.setAttribute('data-product-id', variant.product_id);
      }
    }
  });
})();